import React from 'react';
import { Link } from 'react-router-dom';

const DocumentList = () => {
    return (
        <div className="container py-5 animate__animated animate__fadeIn">
            <div className="row justify-content-center">
                <div className="col-md-8 col-lg-6 text-center">
                    <div className="card border-0 shadow-lg rounded-4 p-5">
                        <div className="mb-4">
                            <div className="display-1 text-success mb-3">
                                <i className="bi bi-check2-circle"></i>
                            </div>
                            <h2 className="fw-bold text-dark">Demande Envoyée !</h2>
                        </div>
                        
                        <div className="mb-4">
                            <p className="lead text-secondary mb-4">
                                Merci de nous avoir contacté, votre demande a été enregistrée et nous vous contacterons bientôt.
                            </p>
                            <div className="p-3 bg-light rounded-3 mb-4">
                                <p className="small text-muted mb-0">
                                    Un membre de l'équipe <strong>Pax Driver</strong> examine actuellement vos informations. 
                                    Nous reviendrons vers vous par téléphone.
                                </p>
                            </div>
                        </div>

                        <div className="d-grid gap-2">
                            <Link to="/" className="btn btn-warning btn-lg fw-bold rounded-pill shadow-sm py-3">
                                Retour à l'accueil
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DocumentList;
